module.exports = __webpack_public_path__ + "cffff06842a8b37a1d9c767737eeb9.png";